export default __webpack_public_path__ + "static/media/twitter_image_1024x512.10e6226b.png";